import { render, staticRenderFns } from "./selectSizeModal.vue?vue&type=template&id=23c6bef8&scoped=true"
import script from "./selectSizeModal.vue?vue&type=script&lang=js"
export * from "./selectSizeModal.vue?vue&type=script&lang=js"
import style0 from "./selectSizeModal.vue?vue&type=style&index=0&id=23c6bef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c6bef8",
  null
  
)

export default component.exports